import {
  DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_BEGIN,
  DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_SUCCESS,
  DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_FAILURE,
  DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
export function updateDirectusTables(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_BEGIN,
    });
    const { projectId, version, dbUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/directus/fields-tables/${dbUuid}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateDirectusTablesError() {
  return {
    type: DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_BEGIN:
      return {
        ...state,
        updateDirectusTablesPending: true,
        updateDirectusTablesError: null,
      };

    case DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_SUCCESS:
      return {
        ...state,
        updateDirectusTablesPending: false,
        updateDirectusTablesError: null,
      };

    case DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_FAILURE:
      return {
        ...state,
        updateDirectusTablesPending: false,
        updateDirectusTablesError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_DISMISS_ERROR:
      return {
        ...state,
        updateDirectusTablesError: null,
      };

    default:
      return state;
  }
}
